<template>
  <div class="container">
    <header class="header">
      <div class="icon-back" @click="onBack()"></div>
      <div class="title">{{ title }}</div>
    </header>
    <main v-html="content" ></main>
  </div>
</template>

<script>
import { apiHelp } from "../../api/index";
export default {
  data: () => ({
    content: "",
    title: "",
    page: {
      current: 1,
      size: 50,
      total: 0,
    },
  }),
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const { data: resp } = await apiHelp({ ...this.page });
      for (let i = 0; i < resp.records.length; i++) {
        if (resp.records[i].problem_name == "组件教程") {
          this.title = resp.records[i].problem_name;
          this.content = resp.records[i].info;
        }
      }
    },
    onBack() {
      return backapp.postMessage("back");
    },
    
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Microsoft YaHei";
  .header {
    position: fixed;
    width: 100%;
    height: 1.12rem;
    left: 0;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    background: #fff;
    .icon-back {
      position: absolute;
      left: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.44rem;
      height: 0.44rem;
      background: url("../../assets/img/icon-arrow-left.png") no-repeat;
      background-size: contain;
    }
    .title {
      flex: 1;
      text-align: center;
      font-size: 0.36rem;
      color: #2c2e35;
    }
  }
  main {
    padding: 0.24rem;
    padding-top: 1.12rem;
  }
}
</style>
